import {SERVICES_KFZ_ACTIONS} from "../actions/types";
import {shouldUpdateExtend, updateCache} from "ith-redux-helpers";
import {filterObj, tryable} from "ah-lib";
import isArray from 'lodash/isArray';

const defaultState = {
	kfz_2_service: {},
	service_2_kfz: {},
	service_2_model: {},
	cache: {}
};

const _kfz_2_service_ident = (kfz_id) => `kfz_2_service_${kfz_id}`;
const _service_2_kfz_ident = (service_id) => `service_2_kfz_${service_id}`;
// const _service_2_kfz_model_ident = (service_id, kfz_id) => `service_2_kfz_model_${service_id}_${kfz_id}`;

export default (state = defaultState, {type, kfz_id, service_id, list, data, cache=true, force=false}) => {
	switch (type) {
		case SERVICES_KFZ_ACTIONS.SET_KFZ:
			// cache test
			if ( cache && state.kfz_2_service[kfz_id] && !shouldUpdateExtend(_kfz_2_service_ident(kfz_id))) {
				return state;
			}
			return {
				...state,
				kfz_2_service: {
					...state.kfz_2_service,
					[kfz_id]: list
				},
				cache: {
					...state.cache,
					...updateCache(_kfz_2_service_ident(kfz_id))
				}
			};
		case SERVICES_KFZ_ACTIONS.SET_SERVICE:
			// cache test
			if ( !force && cache && state.service_2_kfz[service_id] && !shouldUpdateExtend(_service_2_kfz_ident(service_id))) {
				return state;
			}
			return {
				...state,
				service_2_kfz: {
					...state.service_2_kfz,
					[service_id]: list
				},
				cache: {
					...state.cache,
					...updateCache(_service_2_kfz_ident(service_id))
				}
			};
		case SERVICES_KFZ_ACTIONS.UPDATE_KFZ_OF_SERVICE:
			kfz_id = data.kfz_id;
			service_id = data.service_id;
			return {
				...state,
				service_2_kfz: {
					...state.service_2_kfz,
					[service_id]: {
						...state.service_2_kfz[service_id],
						[kfz_id]: data
					}
				},
				cache: {
					...state.cache,
					...updateCache(_service_2_kfz_ident(service_id))
				}
			};
		case SERVICES_KFZ_ACTIONS.REMOVE_KFZ_OF_SERVICE:
			return {
				...state,
				service_2_kfz: {
					...state.service_2_kfz,
					[service_id]: {
						...filterObj(state.service_2_kfz[service_id])(data => data.kfz_id !== kfz_id)
					}
				}
			};
		case SERVICES_KFZ_ACTIONS.SET_MODELS:
			// if ( cache && state.service_2_model[kfz_id] && !shouldUpdateExtend(_kfz_2_service_ident(kfz_id))) {
			// 	return state;
			// }
			return {
				...state,
				service_2_model: {
					...state.service_2_model,
					[service_id]: {
						...state.service_2_model[service_id] || {},
						[kfz_id]: {
							...state.service_2_model[service_id] ? (state.service_2_model[service_id][kfz_id] || {}) : {},
							...list
						}
					}
				}
			};
		case SERVICES_KFZ_ACTIONS.REMOVE_MODELS:
			console.info(service_id, kfz_id, list, state.service_2_model[service_id]);
			if ( isArray(list) ) {
				return {
					...state,
					service_2_model: {
						...state.service_2_model,
						[service_id]: {
							...state.service_2_model[service_id] || {},
							[kfz_id]: {
								...filterObj(state.service_2_model[service_id][kfz_id] || {})(data => !list.includes(data.model_id))
							}
						}
					}
				};
			}
			return {
				...state,
				service_2_model: {
					...state.service_2_model,
					[service_id]: {
						...state.service_2_model[service_id] || {},
						[kfz_id]: {
							...filterObj(tryable(state.service_2_model[service_id][kfz_id])({}))(data => !list[data.model_id])
						}
					}
				}
			};
		default:
			return state;
	}
};


// WEBPACK FOOTER //
// ./src/reducers/services2kfzReducer.js